<template>
    <div v-if="typeof clicked === 'undefined'" tabindex="0"
         class="button noselect"
    >
        <img v-if="typeof imgSrc !== 'undefined'" :src="imgSrc" alt="">
        {{btnTxt}}
    </div>
    <div v-else class="button noselect" tabindex="0"
         v-on:click="disabled == 'true' ? ' ' : clicked(hiddenKey)"
    >
        <img v-if="typeof imgSrc !== 'undefined'" :src="imgSrc" alt="">
        {{btnTxt}}
    </div>
</template>

<script>
    export default {
        name: "BBtnThird",
        props: {
            imgSrc: String,
            btnTxt: String,
            clicked: Function,
            hiddenKey: String,
            disabled: String,
        },
        data() {
            return {}
        },
        methods: {}
    }
</script>

<style scoped>
    .button {
        /*width: 88px;*/
        height: 38px;
        background: #4FBDE9;
        border-radius: 5px;
        color: white;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 5px;
        cursor: pointer;
        font-size: 14px;
        padding: 0 10px;
    }

    :focus {
        outline: none;
    }

    .button:hover,
    .button:focus {
        background: #66d0ff;
    }

    .button:active {
        background: #4098bb;
    }

    .button img {
        width: 18px;
        height: 18px;
        margin-right: 5px;
    }

    .noselect {
        -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Safari */
        -khtml-user-select: none; /* Konqueror HTML */
        -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
        user-select: none;
        /* Non-prefixed version, currently
                                         supported by Chrome and Opera */
    }
</style>